import React from 'react';

import { Grid, Input, MenuItem, Select, Typography } from '@material-ui/core';

import { resourcePrivacyFilterList } from '../../models/Resource';

export default ({ onPrivacyChange, selectedPrivacy }) => {
  return (
    <Grid container item alignItems="center" xs={12} sm={4}>
      <Typography>Privacy: &nbsp;</Typography>
      <Select displayEmpty value={selectedPrivacy} onChange={onPrivacyChange} input={<Input disableUnderline />}>
        <MenuItem value="">All</MenuItem>
        {resourcePrivacyFilterList.map(({ label, value }) => (
          <MenuItem key={value} value={value}>
            {label}
          </MenuItem>
        ))}
      </Select>
    </Grid>
  );
};
